import { Box, Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";

export default function InfoStep01() {

  const { getValues } = useFormContext()
  const { step01 } = getValues()
  
  return (
    <>
      <Box display={'flex'} gap={4} flexWrap={'wrap'}>
          <TableView
          title="Conta corrente"
          text={`${step01.conta_contabil.codigo_contabil} - ${step01.conta_contabil.nome}`}
          />
          <TableView
          title="Data dos lançamentos"
          text={`${step01.data_lancamentos.format('DD/MM/YYYY')}`}
          />
          <TableView
          title="Operação"
          text={`${step01.operacao.id} - ${step01.operacao.nome}`}
          />
           <TableView
          title="Tipo lançamento"
          text={`${step01.tipo_lancamento.id} - ${step01.tipo_lancamento.nome}`}
          />
           <TableView
          title="D/C"
          text={`${step01.debito_credito}`}
          />
           <TableView
          title="Débito / CC"
          text={`${step01.debito_label}`}
          />
           <TableView
          title="Crédito / CC"
          text={`${step01.credito_label}`}
          />
      </Box>
    </>

  )
}

function TableView({ title, text }:TableViewProps) {
  return (
    <Box mb={1}>
      <Typography variant="subtitle2" color="textSecondary">
        {title}
      </Typography>
      <Typography variant="subtitle1">
        {text}
      </Typography>
    </Box>
  );
}

interface TableViewProps {
  title: string;
  text: string;
}